// Thin shim that re-exports the official r180 addons OBJLoader.
// OBJLoader adds .obj 3D model support to YDBoxVolume (setRes id=4).
// See libs/three.js/examples/jsm/loaders/OBJLoader.js for the actual implementation.
export { OBJLoader } from '../../libs/three.js/examples/jsm/loaders/OBJLoader.js';
